// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 23) return "./default/chunk-html-box-reg-wall.b12a9dc9d3d6898e9d88.js";
	if (chunkId === 33) return "./default/chunk-recombee-init.6aad23b62fdba2a1fc5d.js";
	if (chunkId === 24) return "./default/chunk-lazyload-images.f77c1cdc0869da154018.js";
	if (chunkId === 21) return "./default/chunk-gtm-highlight.6f28bed28f55096baaa4.js";
	if (chunkId === 31) return "./default/chunk-progressBar.0364e5efe5dd9b3620d2.js";
	if (chunkId === 13) return "./default/chunk-accordion.64733511ad17fbe1dbc6.js";
	if (chunkId === 18) return "./default/chunk-fadeInOnEnterViewport.b2f32b525656cf26d115.js";
	if (chunkId === 27) return "./default/chunk-megamenu.b7acf6518cf23c1cb41b.js";
	if (chunkId === 22) return "./default/chunk-header.4aa05fb73d17bcc92944.js";
	if (chunkId === 26) return "./default/chunk-mainNavigation.d70e73c79dab683a29f5.js";
	if (chunkId === 28) return "./default/chunk-modal.3fc9f8b33420eb135130.js";
	if (chunkId === 64) return "./64.f8b5bedcefb3f67ab307.js";
	if (chunkId === 20) return "./default/chunk-gallery.e3694aae920e0ce29377.js";
	if (chunkId === 17) return "./default/chunk-enquiry.13268715dfd043cd6f5b.js";
	if (chunkId === 37) return "./default/chunk-survey.9728af29f25b514f0531.js";
	if (chunkId === 19) return "./default/chunk-forum.7c30be798b507f5ecbdf.js";
	if (chunkId === 60) return "./60.b5fb0d4d5f600a27cc7e.js";
	if (chunkId === 32) return "./default/chunk-recombee.975d597d60ca079907bb.js";
	if (chunkId === 61) return "./61.3830a625d7d427a018c6.js";
	if (chunkId === 25) return "./default/chunk-load-more.c2f26d793d7804d95369.js";
	if (chunkId === 39) return "./default/chunk-uncover-behav-articles.80b1a66a06255f2a5cd7.js";
	if (chunkId === 14) return "./default/chunk-ads-repeater.f0e11450847661cdf6cb.js";
	if (chunkId === 46) return "./default/newsletter.418520052d5be009a77b.js";
	if (chunkId === 41) return "./default/companySubscription.7831027a90bba80a6077.js";
	if (chunkId === 49) return "./default/swiper.01a3a7f488f339f6b0e7.js";
	if (chunkId === 51) return "./default/thingsArticleSwiper.f73342a6fbdc157dfe29.js";
	if (chunkId === 16) return "./default/chunk-editorial-promo.4992312733ebba586be3.js";
	if (chunkId === 52) return "./default/topic-banner.12e9cced80ddd65e8e3b.js";
	if (chunkId === 44) return "./default/instagram.1d54fa50f5eb3401f914.js";
	if (chunkId === 47) return "./default/piano.2fff179e7b8ebce379e4.js";
	if (chunkId === 62) return "./62.b999cd2ea6c830f78277.js";
	if (chunkId === 48) return "./default/portaInit.036c838d23368af7207f.js";
	if (chunkId === 45) return "./default/jakebox.4eda10a84f1956bf61fc.js";
	if (chunkId === 40) return "./default/collapser.d22ea3608f967ddfcd13.js";
	if (chunkId === 12) return "./default/author-card-list.5ffb434a39dbf8a71e93.js";
	if (chunkId === 11) return "./chunk-todayResultSliderHP.9a71b0d0f40d2b97afcf.js";
	if (chunkId === 6) return "./chunk-previewMatchesListVideoSlider.8dcf1675c1fb03bba1d7.js";
	if (chunkId === 4) return "./chunk-headermenuflat.88beb625da7c146ec9ed.js";
	if (chunkId === 43) return "./default/info-toggle.cc3131078fffaae1c723.js";
	if (chunkId === 50) return "./default/tabs.006c56e86948e267e6d1.js";
	if (chunkId === 10) return "./chunk-sportmodDayResultDatepicker.82963faa449b15a9b1d6.js";
	if (chunkId === 63) return "./63.b80dadacd8ea8437c09c.js";
	if (chunkId === 8) return "./chunk-sportmod-live-match-websocket-updater.82092f04497da11ea543.js";
	if (chunkId === 7) return "./chunk-sportmod-league-phase-reloader.dc492c76136b3b673937.js";
	if (chunkId === 9) return "./chunk-sportmod-matches-with-table-phase-reloader.66f7a3919ff66692a8d8.js";
	// return url for filenames based on template
	return undefined;
};